
export default class StateContextProvider {

  private static instance: StateContextProvider;

  private props: any = {}

  public static getInstance(): StateContextProvider {

    if(!StateContextProvider.instance){
      StateContextProvider.instance = new StateContextProvider();
      this.instance.props = JSON.parse(sessionStorage.getItem("contextProps") ?? "{}");
    }

    return this.instance;
  }

  private save() {
    sessionStorage.setItem("contextProps", JSON.stringify(this.props));
  }

  public getProp(name: string) {
    return this.props[name];
  }

  public setProp(name: string, value: any) {
    this.props[name] = value;
    this.save();
  }
}
